<template>
  <v-layout column justify-center align-center>
    <v-btn
      slot="activator"
      flat
      small
      color="accent"
      @click="openModalAvatar()">
      <span v-if="!user.avatar.url">
        <v-icon left>mdi-camera</v-icon>
        Enviar foto
      </span>
      <span v-if="user.avatar.url">Alterar</span>
    </v-btn>

    <modal-avatar />
  </v-layout>
</template>

<script>
import ModalAvatar from '@/components/account/avatar/ModalAvatar';

export default {
  name: 'UploadAvatar',
  components: {
    ModalAvatar,
  },
  data() {
    return {
      modalAvatar: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openModalAvatar() {
      this.$store.dispatch('toggleModalAvatar', true);
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/account/avatar/UploadAvatar.vue